import { Link } from "react-router-dom";
import { EmptyState } from "../components/EmptyState";
import { useDocumentTitle } from "../lib/useDocumentTitle";

export function NotFoundPage() {
  useDocumentTitle("页面不存在");
  return (
    <div className="page-frame">
      <EmptyState
        eyebrow="404 · WRONG TURN"
        title="这里没有演讲"
        body="地址可能写错了，或者这条学习记录已经被删除。"
        action={<Link to="/" className="button button-primary">回到学习库</Link>}
      />
    </div>
  );
}

